import React, { useState, useEffect } from "react";
import { func, string } from "prop-types";
import { connect } from "react-redux";
import { parseUrl } from "query-string";
import get from "lodash/get";

import PasswordField from "../../atoms/PasswordField";
import Button from "../../atoms/Button";
import MessageView from "../../atoms/MessageView";
import HeaderWrapper from "../../header/header-wrapper";

import { resetPassword } from "../../helper/api";
import { validatePassword } from "../../utils/utils";
import { setLoading } from "../../helper/actions";
import { RedIconWithText } from "../../molecules/RedIconwithtext";

import "./reset-password.m.css";

const ResetPasswordView = ({ currentPath, setLoading, authHost, redirectUrl, callbackUrl, sketchesHost }) => {
  const [user, setUser] = useState({
    password: "",
    repeatPassword: ""
  });
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null); // Store the token which is received in the query params

  useEffect(() => {
    // To be called only once during the first load
    const params = parseUrl(currentPath);

    if (params) {
      // Validate the opt and member id
      const queryToken = get(params, ["query", "token"], "");

      if (queryToken) {
        // Set the state if both exists
        setToken(queryToken);
      } else {
        setError("Invalid Request !! Please try again");
      }
    } else {
      setError("Invalid Request !! Please try again");
    }
  }, []);

  const setData = e => {
    const userObj = { ...user };
    const fieldName = e.target.name;
    userObj[fieldName] = e.target.value;

    // If error has been set then remove it
    if (e.target.value && userObj[`${fieldName}Error`]) {
      userObj[`${fieldName}Error`] = "";
    }

    // If error is set remove it since data is changed
    if (error) {
      setError(null);
    }

    setUser(userObj);
  };

  const onSubmitClick = e => {
    e.preventDefault();

    if (validate()) {
      // true -> field errors, false - no fields errors
      return;
    }

    // If error is set remove before making api call
    if (error) {
      setError(null);
    }

    setLoading(true);

    resetPassword(token, user.password, user.repeatPassword)
      .then(() => {
        window.location.href = `${authHost}/sign-in-page?callback-url=${sketchesHost}&redirect-url=${sketchesHost}`;
      })
      .catch(ex => setError(ex || "Invalid Request !! Please try to do a forgot password again."))
      .finally(() => setLoading(false));
  };

  const validate = () => {
    const updatedUser = { ...user };
    let flag = false;

    let pwdError = validatePassword(updatedUser.password);

    if (pwdError) {
      updatedUser.passwordError = pwdError;
      flag = true;
    } else {
      updatedUser.passwordError = null;
    }

    pwdError = validatePassword(updatedUser.repeatPassword);

    if (pwdError) {
      updatedUser.repeatPasswordError = pwdError;
      flag = true;
    } else {
      updatedUser.repeatPasswordError = null;
    }

    if (updatedUser.password && updatedUser.repeatPassword) {
      // If password's exists then check if both are same
      if (updatedUser.password !== updatedUser.repeatPassword) {
        setError("Password and Repeat Password do not match");
        flag = true;
      }
    }

    // If flag is true, there are field error's
    if (flag) {
      setUser(updatedUser); // update state with field errors
    }

    return flag;
  };

  const mainView = (
    <React.Fragment>
      <PasswordField
        value={user.password}
        error={user.passwordError}
        placeholder="Password"
        name="password"
        onChange={setData}
      />

      <PasswordField
        value={user.repeatPassword}
        error={user.repeatPasswordError}
        placeholder="Repeat Password"
        name="repeatPassword"
        onChange={setData}
      />

      <span styleName="message">Use 8 or more characters with a mix of letters, number & symbols</span>

      <Button content="RESET" type="submit" buttonType="type3" />
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <HeaderWrapper hideTopAd={true} />
      <div styleName="wrapper">
        <div styleName="reset-msg">Reset your Password</div>
        <div styleName="content-container">
          <form onSubmit={onSubmitClick}>
            <div styleName="form-wrapper">
              <div styleName="password-field-container">
                <MessageView type="error" text={error} />
                {token ? mainView : null}
              </div>
            </div>
          </form>
          <RedIconWithText />
        </div>
      </div>
    </React.Fragment>
  );
};

ResetPasswordView.defaultProps = {
  redirectUrl: global.location && global.location.href,
  callbackUrl: global.location && global.location.origin
};

ResetPasswordView.propTypes = {
  currentPath: string,
  navigateToPage: func,
  setLoading: func,
  authHost: string,
  redirectUrl: string,
  callbackUrl: string,
  sketchesHost: string
};

const mapStateToProps = state => ({
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com")
});

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url),
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

const ResetPasswordPage = connect(mapStateToProps, mapDispatchToProps)(ResetPasswordView);

export { ResetPasswordPage };
